import { createFileRoute } from '@tanstack/react-router'
import { LedgerScreen } from '../features/ledger'

// Payment owed, a sibling of /ledger (the trailing underscore un-nests it from the ledger screen).
export const Route = createFileRoute('/ledger_/payment-owed')({
  component: function PaymentOwedRoute() {
    return <LedgerScreen initialLane="payment_owed" />
  },
})
